import selectors from './selectors'
import slice from './slice'
import actions from './actions'

export { slice as dialogSlice, selectors as dialogSelectors, actions as dialogActions }
